var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activationData"},[_c('div',{staticClass:"col-12 row text-center mx-0 table-responsive"},[_c('b-table',{staticClass:"activationData-table-detail activationData-table-detail-select",attrs:{"items":_vm.activationDataItem,"fields":_vm.activationDataFields,"sticky-header":"240px","no-border-collapse":true}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e5e572e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/activationData.vue
// module id = null
// module chunks = 